import React from "react";
import { AbstractDate, Period } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import FormatedDate from "@ui-kit/format/date";
import { tr } from "@radarly/i18n";

export default function SubheaderPeriod({
  period,
  locale,
  timezone,
  nowDate,
}: {
  period: Period;
  locale: Locale;
  timezone: Timezone;
  nowDate: AbstractDate;
}) {
  return (
    <span>
      {tr(locale, "INSIGHT_PAGES::PAGE::SNAPSHOT-SELECTED-PERIOD")}{" "}
      <FormatedDate
        from={period.from}
        to={period.to}
        locale={locale}
        timezone={timezone}
        nowDate={nowDate}
      />
    </span>
  );
}
